import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PageHero } from "@/components/PageHero";
import { Contact } from "@/components/Contact";
import { usePageSeo } from "@/hooks/usePageSeo";
import { images } from "@/data/site";

export default function ContactPage() {
  usePageSeo({ title: "Contact Shyam Equipment and Infratech | Request a Quote", description: "Contact Shyam Equipment and Infratech for manpower supply, equipment rental, and transaction support across India.", path: "/contact" });
  return (
    <main className="text-industrial-text" data-testid="contact-page">
      <Header />
      <PageHero eyebrow="Contact" title="Tell us what your project needs next" description="Send a detailed enquiry for manpower, machinery, or transaction support. For urgent requirements, use the WhatsApp quote button or call directly." image={images.hero} imageAlt="Industrial cranes at a project site" primaryLabel="Open Enquiry Form" primaryHref="#contact" testId="contact-page-hero" />
      <Contact />
      <Footer />
    </main>
  );
}
